module.exports = __webpack_public_path__ + "img/success.e752db4c.png";